var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"flex-header"},[_c('div',{staticClass:"flex"},[_vm._t("flex")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }